import { render, staticRenderFns } from "./InitLoader.vue?vue&type=template&id=4b734d9e&scoped=true&"
import script from "./InitLoader.vue?vue&type=script&lang=js&"
export * from "./InitLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b734d9e",
  null
  
)

export default component.exports